
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 15","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.703 14.477a.639.639 0 001.067 0C9.762 8.734 10.5 8.133 10.5 6A5.251 5.251 0 005.25.75 5.234 5.234 0 000 6c0 2.133.71 2.734 4.703 8.477zm.547-6.29A2.16 2.16 0 013.062 6c0-1.203.958-2.188 2.188-2.188 1.203 0 2.188.985 2.188 2.188 0 1.23-.985 2.188-2.188 2.188z"}})])
          )
        }
      }
    